import { FC } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import clsx from 'clsx'

import useActiveWebinars from 'store/navbar/useActiveWebinars'
import ButtonToPayment from 'components/parts/button-to-payment/button-to-payment'

import { IObj } from 'constants/types/common.types'
import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'
import { STATIC_URL, PROD_STATIC_PATH } from 'constants/data'

import styles from './banner-not-avaliable.module.scss'

const imgPath = {
  warning: `${STATIC_URL}/icons/icon_warning.svg`,
}

// TODO to constants
const Text = {
  MATERIALS: 'получения доступа',
  NMO: 'получения баллов НМО',
  WEBINAR: 'просмотра вебинара',
  CASES: 'отправки клинического случая',
  UNAVAILABLE_RECORD: 'Запись временно недоступна',
}

interface INotAvaliable {
  modificator:
    | 'MATERIALS'
    | 'NMO'
    | 'WEBINAR'
    | 'CASES'
    | 'PAID_WEBINAR'
    | 'UNAVAILABLE_RECORD'
    | 'RECORD_WITHOUT_VIDEO'
  outer?: boolean
  PaymentData?: IObj<string | number>
}

const NotAvaliable: FC<INotAvaliable> = ({
  modificator,
  outer = false,
  PaymentData,
}: INotAvaliable) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)
  const { isPageWithActiveWebinar } = useActiveWebinars()

  const BlockToRender = () => {
    if (modificator === 'PAID_WEBINAR')
      return (
        <div>
          <p className={styles.contentParagraph}>
            Доступ к вебинару платный, так как мы не привлекаем партнеров к организации мероприятия.
            Запись и материалы семинара доступны сразу после оплаты. Нажимая кнопку
            &quot;Оплатить&quot;, вы соглашаетесь с условиями&nbsp;
            <a
              href={`${PROD_STATIC_PATH}/oferta_access_services.pdf`}
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              оферты
            </a>
          </p>
          <ButtonToPayment
            PaymentData={PaymentData}
            wrapperModificator={styles.btnWrapper}
            buttonModificator={styles.landingBtn}
            text="Оплатить"
          ></ButtonToPayment>
        </div>
      )
    if (modificator === 'UNAVAILABLE_RECORD')
      return (
        <p>
          По техническим причинам запись временно недоступна 😔 <br />
          Мы сообщим по почте, когда появится лекция ❤️
        </p>
      )
    if (modificator === 'RECORD_WITHOUT_VIDEO') return <p>Данный вебинар был без записи 😔</p>
    return (
      <div>
        {modificator === 'MATERIALS' && (
          <p className={styles.contentParagraph}>
            Доступ к материалу ограничен. Материалы сайта предназначены исключительно для работников
            здравоохранения, имеющих высшее медицинское образование.
          </p>
        )}
        <p>
          Для {Text[modificator]}, пожалуйста,&ensp;
          <Link href={`${path}#${popupName.registration}`}>
            <span className={styles.link}>войдите</span>
          </Link>
          &ensp;или&ensp;
          <Link
            href={
              isPageWithActiveWebinar
                ? `${path}#${popupName.registration}`
                : `${path}#${popupName.registration}`
            }
          >
            <span className={styles.link}>зарегистрируйтесь</span>
          </Link>
          .
        </p>
      </div>
    )
  }

  return (
    <div
      className={clsx(styles.warning, {
        [styles.outerWarning]: outer,
        [styles.nmo]: modificator === 'NMO',
        [styles.webinar]: modificator === 'WEBINAR',
        [styles.clinic]: modificator === 'CASES',
        [styles.unavailableRecord]: modificator === 'UNAVAILABLE_RECORD',
        [styles.blackFrame]: modificator === 'RECORD_WITHOUT_VIDEO',
      })}
    >
      <img
        src={imgPath.warning}
        className={styles.warningIcon}
        alt="Предупреждение"
        decoding="async"
        loading="lazy"
      />
      {BlockToRender()}
    </div>
  )
}

export default NotAvaliable
